import React from "react";
import { formatTimeRemaining } from "../utils/timeHelper";
import PlatformIconsCarousel from "./PlatfromIconsCarousel";
import { renderPlatformIcon } from "./PlatformIcon";
import { Box, IconButton, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faEye, faAnglesLeft, faAnglesRight, faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import nodata from "../../../../../images/nodata2.png";
import "../../style/Pagination.css";


const TopicCards = ({
  allTopics,
  timers,
  pagination,
  filters,
  setSelectedTopicIndex,
  setViewDrawerOpen,
  handleEdit,
  getAllTopics,
  sseStatus,
}) => {
  const formatStatus = (status) =>
    status ? status.charAt(0).toUpperCase() + status.slice(1) : "Unknown";

  const formatCount = (val) => {
    if (val === undefined || val === null) return "--";
    return typeof val.toLocaleString === "function" ? val.toLocaleString() : String(val);
  };

  return (
    <>
      {allTopics && allTopics?.length > 0 ? (
        <>
          <div className="cards-container">
            {allTopics.map((topic, index) => (
              <div key={topic._id} className="topic-card">
                <div className="topic-title">
                  <span className="topic-value">{topic.topic}</span>

                  <div className="topic-subtitle">
                    <span className="topic-label">Objective:</span>
                    <span className="topic-type">{topic.type} Analysis</span>
                  </div>

                  {/* Crawl Status */}
                  <div className="topic-subtitle">
                    <span className="topic-label">Crawl Status:</span>
                    <span className={`topic-status status-${topic.status}`}>
                      {formatStatus(topic.status)}
                    </span>
                    {topic.crawl_end_at && timers[topic._id] && (
                      <span
                        className={`topic-timer ${
                          timers[topic._id].expired
                            ? "timer-expired"
                            : timers[topic._id].total < 300000
                              ? "timer-critical"
                              : timers[topic._id].total < 600000
                                ? "timer-warning"
                                : ""
                        }`}
                      >
                        {timers[topic._id].expired ? (
                          <>✓ {formatTimeRemaining(timers[topic._id])}</>
                        ) : timers[topic._id].total < 300000 ? (
                          <>🔥 {formatTimeRemaining(timers[topic._id])}</>
                        ) : (
                          <>⏱ {formatTimeRemaining(timers[topic._id])}</>
                        )}
                      </span>
                    )}
                  </div>

                  {/* Analysis (Pipeline) Status */}
                  <div className="topic-subtitle">
                    <span className="topic-label">Analysis Status:</span>
                    <span className={`topic-status pipeline-status-${topic.pipeline_status ?? "unknown"}`}>
                      {String(topic.pipeline_status ?? "unknown")}
                    </span>
                  </div>

                 
                </div>

                {/* Platform Icons */}
                <PlatformIconsCarousel
                  platforms={topic.platform}
                  renderPlatformIcon={renderPlatformIcon}
                />

                {/* Post Counts — numbers update in real-time via SSE */}
                <div className="data-count">
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <span className="stats-eyebrow">Data Overview</span>
                    {sseStatus === "live" && (
                      <span style={{
                        fontSize: "10px",
                        fontFamily: "Host Grotesk, sans-serif",
                        fontWeight: 600,
                        color: "#10b981",
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                      }}>
                        <span style={{
                          width: 5,
                          height: 5,
                          borderRadius: "50%",
                          backgroundColor: "#10b981",
                          display: "inline-block",
                          animation: "ssePulse 1.5s ease-in-out infinite",
                        }} />
                        live
                      </span>
                    )}
                  </div>
                  <div className="stats-hero">
                    <span className="hero-number">{formatCount(topic.data_count)}</span>
                    <span className="hero-label">Total Posts</span>
                  </div>
                  <div className="stats-pills">
                    <span className="stat-pill stat-pill-green">
                      <span className="pill-dot" />
                      <span className="pill-num">{formatCount(topic.processed_posts)}</span>
                      <span className="pill-lbl">Processed</span>
                    </span>
                    <span className="stat-pill stat-pill-amber">
                      <span className="pill-dot" />
                      <span className="pill-num">{formatCount(topic.unprocessed_posts)}</span>
                      <span className="pill-lbl">Remaining</span>
                    </span>
                  </div>
                </div>

                {/* Actions */}
                <div className="card-actions">
                  <IconButton
                    className="action-btn view-btn"
                    size="small"
                    onClick={() => {
                      setSelectedTopicIndex(index);
                      setViewDrawerOpen(true);
                    }}
                  >
                    <FontAwesomeIcon icon={faEye} />
                    View
                  </IconButton>

                  <IconButton
                    className="action-btn edit-btn"
                    size="small"
                    onClick={() => handleEdit(topic._id)}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                    Edit
                  </IconButton>
                </div>
              </div>
            ))}
          </div>

          {/* Pagination */}
          {pagination.total_pages > 1 && (() => {
            const currentPage  = pagination.page;
            const totalPages   = pagination.total_pages;
            const isFirstPage  = currentPage === 1;
            const isLastPage   = currentPage === totalPages;

            const goToPage = (page) => {
              const { platform, sortBy, pageSize } = filters;
              getAllTopics(
                page,
                pageSize,
                platform || null,
                sortBy === "most_counts" ? true : null,
                sortBy === "oldest" ? true : null,
              );
            };

            return (
              <div className="pagination-container">
                <button
                  onClick={() => goToPage(1)}
                  disabled={isFirstPage}
                  className="pagination-button pagination-button--edge"
                  aria-label="First page"
                >
                  <FontAwesomeIcon icon={faAnglesLeft} />
                </button>

                <button
                  onClick={() => goToPage(currentPage - 1)}
                  disabled={isFirstPage}
                  className="pagination-button pagination-button--nav"
                  aria-label="Previous page"
                >
                  <FontAwesomeIcon icon={faChevronLeft} />
                </button>

                <div className="page-info">
                  <span className="page-current">{currentPage}</span>
                  <span className="page-sep">/</span>
                  <span className="page-total">{totalPages}</span>
                </div>

                <button
                  onClick={() => goToPage(currentPage + 1)}
                  disabled={isLastPage}
                  className="pagination-button pagination-button--nav"
                  aria-label="Next page"
                >
                  <FontAwesomeIcon icon={faChevronRight} />
                </button>

                <button
                  onClick={() => goToPage(totalPages)}
                  disabled={isLastPage}
                  className="pagination-button pagination-button--edge"
                  aria-label="Last page"
                >
                  <FontAwesomeIcon icon={faAnglesRight} />
                </button>
              </div>
            );
          })()}
        </>
      ) : (
        <div
          style={{
            width: "160vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            alt="No Data"
            src={nodata}
            style={{
              width: "75vh",
            }}
          />
        </div>
      )}
    </>
  );
};

export default TopicCards;
